import React from 'react';
import KickImage from 'Reuseables/KickImage';
import { ModalTopUp, ModalTopUp2, ModalTopUp3 } from '../Modals';
import ModalSnapPay from '../Modals/ModalSnapPay';
import { addError } from '../../utils/Helpers';
import { isNumeric } from '../../helpers/regex';
import {
  getAdmTopupFees as getAdmFees,
  BANKTRANSFER,
  VIRTUALACCOUNT,
  CREDITCARD,
  BCA_VA,
  BRI_VA,
  BNI_VA,
  PERMATA_VA,
  MANDIRI_VA
} from '../../constants/paymentMethods';

class TopupForm extends React.Component{
  constructor(props){
    super(props);
    // const _uniqueAmountDef = this._generateUniqueAmount();
    this.state = {
      _amount: 0,
      _paymentMethod: 'bca_va',
      _step: 1,
      _uniqueAmount: 0,
      _administrationFee: 0,
      _dataResult: null,
      _error: null,
      _isRedirect: false,
      _isAlertErrorOpen: false,
      _alertErrorMsg: '',
      _snapPayment: {
        token: null
      }
      // _uniqueAmountDef,
    }
    this._handleOnToggle = this._handleOnToggle.bind(this);
    this._handleOnAmountChange = this._handleOnAmountChange.bind(this);
    this._handleOnPaymentMethodChange = this._handleSelectChange.bind(this, "_paymentMethod");
    this._handleNextStep = this._handleNextStep.bind(this);
    this._handleOnSubmit = this. _handleOnSubmit.bind(this);
    this._handleOnToggleAlertError = this._handleOnToggleAlertError.bind(this);
  }

  componentDidUpdate(prevProps, prevState){
    //When modal topup 2 is open
    if(prevState._step !== this.state._step && this.state._step === 2){
      const _uniqueAmountDef = this._generateUniqueAmount();
      const { _paymentMethod, _amount } = this.state;
      let _administrationFee = this._getAdmFee(_paymentMethod, _amount, 0, 0)
      this.setState({
        _uniqueAmount: _paymentMethod === 'bank_transfer'? _uniqueAmountDef: 0,
        _uniqueAmountDef,
        // _paymentMethod: 'bank_transfer',
        _administrationFee: _administrationFee,
        _isRedirect: false,
      })
    }
    //When already submitted
    if(prevProps.dataTopUp.isSubmit
    && prevProps.dataTopUp.isSubmit !== this.props.dataTopUp.isSubmit){
      const { error, ..._dataResult } = this.props.dataTopUp;
      if(error){
        if(error.status_code === 422){
          const hasErrorFormOne = Object.keys(error.errors).filter(key => key === 'amount').length>0;
          this.setState({
            _error: error,
            _step: hasErrorFormOne? 1: this.state._step
          })
        }
        else{
          this.setState({
            _error: error,
            _isAlertErrorOpen: true,
            _alertErrorMsg: this._getErrorMsg(error.status_code)
          })
        }
      }
      else{
        this.setState({
          _dataResult,
          // _amount: 0,
          _error: null,
          _isAlertErrorOpen: false,
          _isRedirect: _dataResult.invoice_url?true: false
        })
        if(_dataResult.invoice_url && _dataResult.payment_via === 'xnd'){
          setTimeout(()=> window.location = _dataResult.invoice_url, 2000)
        }
        if(_dataResult.invoice_url && _dataResult.payment_via === 'vt'){
          const { payment_gateway } = _dataResult;
          this.setState({
            _snapPayment:{
              token: payment_gateway.transaction_token,
              paymentType: payment_gateway.payment_type,
              redirectUrl: _dataResult.invoice_url,
              invoiceNumber: _dataResult.invoice_number,
              expiredAt: payment_gateway.expired_at
            }
          }, ()=> {
            this._handleNextStep(4);
          })
        }
        else
          this._handleNextStep(3)
      }
    }
    //When closed all popup.
    if(prevProps.isOpen && prevProps.isOpen!==this.props.isOpen){
      this.setState({
        _amount: this.state._dataResult !== null && this.state._dataResult.id? 0:this.state._amount,
        _error: null,
        _isAlertErrorOpen: false,
        _dataResult: null
      })
    }
  }

  _getErrorMsg(statusCode){
    return statusCode !== 200 ? `Oops, something went wrong. (code: ${statusCode})`: null
  }

  _validationFormOne(){
    let errors = {};
    if(!isNumeric(this.state._amount))
      errors['amount'] = addError(errors, 'amount', 'The amount field must be numeric.');
    return errors;
  }

  _validationFormTwo(){
    let errors = {};
    const enablePayments = [
      BANKTRANSFER,
      CREDITCARD,
      VIRTUALACCOUNT,
      BCA_VA,
      BRI_VA,
      BNI_VA,
      PERMATA_VA,
      MANDIRI_VA
    ];
    if(this.state._paymentMethod==="")
      errors['payment_method'] = addError(errors, 'payment_method', 'The payment method field is required.');
    if(!enablePayments.includes(this.state._paymentMethod))
      errors['payment_method'] = addError(errors, 'payment_method', 'The payment method can only be bank transfer or virtual account.');
    return errors;
  }

  _hasErrorForm(errors){
    return Object.keys(errors).length > 0;
  }

  _generateUniqueAmount(){
    let rand = Math.floor(Math.random() * 100);
    while(rand==0){
      rand = Math.floor(Math.random() * 100)
    }
    return rand;
  }

  async _handleOnAmountChange(e){
    let dataTopup = { ...this.state._amount}

    console.log(e.target.value, typeof(e.target.value))

    switch(e.target.name){
      case '_amount':
      dataTopup =
        e.target.value? `${e.target.value.replace(/[^\d]/g, '')}.00` : '0.00'; break;

      default: return null
    }

    await this.setState({
      _amount: parseInt(dataTopup)
    })
  }

  _handleSelectChange (name, { value }) {
    const lastState = {...this.state};
    lastState[name] = value;
    this.setState({
      ...lastState,
      _administrationFee: this._getAdmFee(value, parseInt(this.state._amount), 0, 0),
      _uniqueAmount: value === 'bank_transfer'? this.state._uniqueAmountDef: 0,
    })
  }

  _getAdmFee(paymentType, price, courierPrice, discount){
    return getAdmFees(paymentType, price, courierPrice, discount);
  }

  _handleOnToggle(){
    if(!this.props.dataTopUp.isSubmit || !this.state._isRedirect){
      this.setState({
        _step: 1
      })
      this.props.onToggle()
    }
  }

  _handleNextStep(step){
    if(step === 2){
      const errors = this._validationFormOne();
      if(this._hasErrorForm(errors)) {
        this.setState({
          _error: {
            ...this.state._error,
            errors
          }
        })
      }
      else{
        this.setState({
          _step: step,
          _error: null
        })
      }
    }
    else {
      this.setState({
        _step: step > 0 || step < 5? step : 1
      })
    }
  }

  _handleOnSubmit(){
    const errors = this._validationFormTwo();
    if(this._hasErrorForm(errors)){
      this.setState({
        _error: {
          ...this.state._error,
          errors
        }
      })
    }
    else{
      this.props.onSubmit({
        amount: this.state._amount,
        unique_amount: this.state._uniqueAmount,
        administration_fee: this.state._administrationFee,
        payment_method: this.state._paymentMethod
      })
      this.setState({
        _error: null,
        _isAlertErrorOpen: false
      })
    }
    // this._handleOnToggle()
  }

  _isModalOpen(step){
    return this.props.isOpen && this.state._step === step
  }

  _handleOnToggleAlertError(){
    this.setState({
      _isAlertErrorOpen: !this.state._isAlertErrorOpen
    })
  }

  render(){
    return(
      <div>
        <ModalTopUp
          amount={this.state._amount}
          isOpen={this._isModalOpen(1)}
          // isOpen={this._isModalOpen(4)}
          onTextChange={this._handleOnAmountChange}
          onToggle={this._handleOnToggle}
          onNextPage={this._handleNextStep}
          error={this.state._error}
        />
        <ModalTopUp2
          amount={this.state._amount}
          uniqueAmount={this.state._uniqueAmount}
          administrationFee={this.state._administrationFee}
          paymentMethod={this.state._paymentMethod}
          isOpen={this._isModalOpen(2)}
          onTextChange={this._handleOnPaymentMethodChange}
          onSubmit={this._handleOnSubmit}
          isSubmit={this.props.dataTopUp.isSubmit}
          onToggle={this._handleOnToggle}
          isRedirect={this.state._isRedirect}
          error={this.state._error}
          errorMessage={this.state._alertErrorMsg}
          isAlertErrorOpen={this.state._isAlertErrorOpen}
          onAlertErrorToggle={this._handleOnToggleAlertError}
          // onNextPage={this._handleNextStep}
        />
        <ModalTopUp3
          // amount={this.props.amount}
          isOpen={this._isModalOpen(3)}
          onToggle={this._handleOnToggle}
          dataTopUp={this.state._dataResult}
        />
        <ModalSnapPay
          autoOpenSnapModal
          isOpen={this._isModalOpen(4)}
          isCloseable={this.state._paymentMethod === 'credit_card'}
          // isOpen={this._isModalOpen(1)}
          onToggle={this._handleOnToggle}
          trxToken={this.state._snapPayment.token}
          headerTitle={this.state._snapPayment.invoiceNumber}
          invoiceNumber={this.state._snapPayment.invoiceNumber}
          paymentType={this.state._snapPayment.paymentType}
          bank={this.state._snapPayment.bank}
          redirectUrl={this.state._snapPayment.redirectUrl}
          expiredAt={this.state._snapPayment.expiredAt}
        />
      </div>
    )
  }
}
export default TopupForm;
